import { Stars } from "./Stars";
import { fmtDecimal, fmtPct } from "../utils/formatters";
import { RATING_EMOJIS } from "../constants";

/**
 * 3 cards do topo do relatório:
 *  1) Nota média geral (com estrelas + emoji)
 *  2) Total de respostas — agora com comparativo de envios + % de resposta
 *  3) Distribuição por nota (1..5)
 */
export function SummaryCards({ avgGeral, total, sent, dist }) {
  const responseRate = sent > 0 ? (total / sent) * 100 : 0;
  const maxDist = Math.max(...Object.values(dist || { 5: 0 }), 1);
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card title="Nota média geral">
        <div className="mt-2 flex items-baseline gap-1">
          <span className="text-5xl font-black text-amber-500">{fmtDecimal(avgGeral)}</span>
          <span className="text-lg text-muted-foreground">/ 5,0</span>
        </div>
        {avgGeral != null && (
          <div className="mt-2 flex items-center gap-2">
            <Stars value={avgGeral} />
            <span className="text-sm text-muted-foreground">{RATING_EMOJIS[Math.round(avgGeral)] || ""}</span>
          </div>
        )}
      </Card>

      <Card title="Total de respostas">
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-5xl font-black tabular-nums">{total}</span>
          <span className="text-lg text-muted-foreground tabular-nums">/ {sent}</span>
        </div>
        <p className="text-xs text-muted-foreground mt-2 tabular-nums">
          <span className="font-semibold text-emerald-600">{fmtPct(responseRate)}</span> dos clientes responderam
        </p>
      </Card>

      <Card title="Distribuição">
        <div className="mt-3 space-y-1.5">
          {[5, 4, 3, 2, 1].map((n) => (
            <div key={n} className="flex items-center gap-2 text-xs">
              <span className="w-6 text-right text-muted-foreground">{n}★</span>
              <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full ${
                    n >= 4 ? "bg-emerald-500" : n === 3 ? "bg-amber-500" : "bg-red-500"
                  }`}
                  style={{ width: `${((dist?.[n] || 0) / maxDist) * 100}%` }}
                />
              </div>
              <span className="w-8 text-right font-mono text-muted-foreground">{dist?.[n] || 0}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="bg-card border rounded-2xl p-5">
      <p className="text-xs uppercase tracking-wider text-muted-foreground font-bold">{title}</p>
      {children}
    </div>
  );
}
